import { UURLs } from "@/app/utils/UURLs";

export const APP_URL = UURLs.getServerUrl() || "";

export const SitemapRoutes = {
  HOME: "/",
};

export enum ConfiguratorQuery {
  PAIR = "pair",
  MODEL = "model",
}

// Path suffixes used for route matching (never compare hard-coded strings).
export const RouteSegments = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  CONFIRM_EMAIL: "/confirm-email",
  USERS: "/users",
  CONFIGURATOR: "/configurator",
  LIBRARY: "/library",
  PATIENTS: "/patients",
  SETTINGS: "/settings",
};

type ConfiguratorParams = { pair?: string; model?: string };

const prefix = (lang: string) => `${APP_URL}/${lang}`;
export const Routes = {
  ROOT: (lang: string) => `${prefix(lang)}/`,
  LOGIN: (lang: string) => `${prefix(lang)}/login`,
  FORGOT_PASSWORD: (lang: string) => `${prefix(lang)}/forgot-password`,
  RESET_PASSWORD: (lang: string) => `${prefix(lang)}/reset-password`,
  CONFIRM_EMAIL: (lang: string) => `${prefix(lang)}/confirm-email`,
  PROTECTED: {
    CONFIGURATOR: (lang: string, params?: ConfiguratorParams) => {
      const base = `${prefix(lang)}/configurator`;
      if (params?.pair) {
        return `${base}?${ConfiguratorQuery.PAIR}=${params.pair}`;
      }
      if (params?.model) {
        return `${base}?${ConfiguratorQuery.MODEL}=${params.model}`;
      }
      return base;
    },
    SETTINGS: (lang: string) => `${prefix(lang)}/settings`,
    LIBRARY: (lang: string) => `${prefix(lang)}/library`,
    ADMIN: {
      USERS: (lang: string) => `${prefix(lang)}/users`,
    },
    PRO: {
      PATIENTS: (lang: string) => `${prefix(lang)}/patients`,
    },
  },
};
